<template>
  <div class="Bgc-white">
    <Header />
    <div class="contentContacto">
      <div class="container contacto">
        <div class="row">
          <div class="col-12 mb-3">
            <p class="title">{{$t('language.posadasCorporate.informacionCorporate.infoCorporate')}}</p>
            <p>
              {{$t('language.posadasCorporate.informacionCorporate.text1')}}
            </p>
          </div>
          <div class="col-12 col-md-6">
            <b-card :title="$t('language.posadasCorporate.informacionCorporate.infoAdicional')" tag="article" class="mb-2 card-height-custom">
              <b-card-text>
                {{$t('language.posadasCorporate.informacionCorporate.text2')}}
              </b-card-text>

              <div class="enlacesContacto mb-2">
                <router-link class="link" to="/informacion-adicional">
                  <i class="demo-icon icon-info"></i>{{$t('language.posadasCorporate.informacionCorporate.verInfoAdicional')}}
                </router-link>
              </div>
            </b-card>
          </div>
          <div class="col-12 col-md-6">
            <b-card :title="$t('language.posadasCorporate.informacionCorporate.ayudaReservaciones')" tag="article"
              class="mb-2 card-height-custom">
              <b-card-text>
                {{$t('language.posadasCorporate.informacionCorporate.text3')}}
              </b-card-text>

              <div class="enlacesContacto mb-2">
                <router-link class="link" to="/modificacion-reservaciones">
                  <i class="demo-icon icon-edit"></i>{{$t('language.posadasCorporate.informacionCorporate.modificacionReservaciones')}}
                </router-link>
              </div>
              <div class="enlacesContacto mb-2">
                <router-link class="link" to="/cancelar-reservaciones">
                  <i class="demo-icon icon-close"></i>{{$t('language.posadasCorporate.informacionCorporate.cancelacionReservaciones')}}
                </router-link>
              </div>
              <div class="enlacesContacto mb-2">
                <router-link class="link" to="/aclaracion-reservaciones">
                  <i class="demo-icon icon-help"></i>{{$t('language.posadasCorporate.informacionCorporate.aclaracionReservaciones')}}
                </router-link>
              </div>
            </b-card>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
  import Header from '../../generales/Header.vue';
  import Footer from '../../generales/Footer.vue';
  export default {
    name: 'Contacto',
    components: {
      Header,
      Footer,
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../assets/scss/config.scss';
  .card-height-custom {
    min-height: 213.67px;
    height: 213.67px;
    .card-body {
      min-height: 213.67px;
      height: 213.67px;
    }
  }
</style>